// Auto generated file, do not manually modify!
// com.hotpads.rins.client.enums.UpsellType

export enum UpsellType {
  APPLICATION_APPROVED_DELAYED_PUSH = 'APPLICATION_APPROVED_DELAYED_PUSH',
  APPLICATION_APPROVED_EMAIL = 'APPLICATION_APPROVED_EMAIL',
  APPLICATION_SUBMITTED = 'APPLICATION_SUBMITTED',
  CONTACTED_RENTALS = 'CONTACTED_RENTALS',
  HOME_DETAILS = 'HOME_DETAILS',
  LEASES_PAGE = 'LEASES_PAGE',
  LEASE_SIGNED_EMAIL = 'LEASE_SIGNED_EMAIL',
  LEASE_SIGNED_FLOW = 'LEASE_SIGNED_FLOW',
  YOUR_RENTAL_APPLICATIONS = 'YOUR_RENTAL_APPLICATIONS',
  YOUR_RENTAL_PAGE = 'YOUR_RENTAL_PAGE',
}

export const UpsellType_values = [
  UpsellType.APPLICATION_APPROVED_DELAYED_PUSH,
  UpsellType.APPLICATION_APPROVED_EMAIL,
  UpsellType.APPLICATION_SUBMITTED,
  UpsellType.CONTACTED_RENTALS,
  UpsellType.HOME_DETAILS,
  UpsellType.LEASES_PAGE,
  UpsellType.LEASE_SIGNED_EMAIL,
  UpsellType.LEASE_SIGNED_FLOW,
  UpsellType.YOUR_RENTAL_APPLICATIONS,
  UpsellType.YOUR_RENTAL_PAGE,
] as const;
